<template>
  <div class="ar-player">
    <div class="ar-control d-flex align-center">
      <v-icon @click.native="playback">
        {{playBtnIcon}}
      </v-icon>
      <span class="ar-player__time">{{playedTimeMMSS}}</span>
      <line-control
        class="ar-player__progress"
        ref-id="progress"
        :percentage="progress"
        @mousedown="_lineControlEvent"
        @mouseup="_lineControlEvent"
        @change-linehead="_onUpdateProgress"/>
      <span class="ar-player__time">{{durationMMSS}}</span>
      <!-- <volume-control @change-volume="_onChangeVolume"/> -->
    </div>
    <audio ref="audio" :src="audioSource"></audio>
  </div>
</template>

<script>
import LineControl from './line-control'
// import VolumeControl from './volume-control'
import { convertTimeMMSS } from './lib/utils'

export default {
  props: {
    src: { type: String },
    record: { type: Object, default: null }
  },
  data () {
    return {
      isPlaying: false,
      isPlayingTmp: null,
      duration: 0,
      playedTime: 0,
      progress: 0
    }
  },
  components: {
    // IconButton,
    LineControl
  },
  mounted: function() {
    this.player = this.$refs.audio

    this.player.addEventListener('ended', () => {
      this.isPlaying = false
    })

    this.player.addEventListener('loadeddata', (ev) => {
      this._resetProgress()
      console.log('audio loadeddata', this.player.duration)
      this.duration = this.player.duration
    })

    this.player.addEventListener('timeupdate', this._onTimeUpdate)

    // this.$eventBus.$on('remove-record', () => {
    //   this._resetProgress()
    // })
  },
  computed: {
    playedTimeMMSS(){
      return convertTimeMMSS(this.playedTime)
    },
    durationMMSS(){
      return convertTimeMMSS(this.duration)
    },
    audioSource () {
      let url = ''
      if(this.reloading){
        url = ''
      }else if(this.src){
        url = this.src
      }else if(this.record && this.record.url){
        url = this.record.url
      }
      // if(url.length > 128){
      //   console.log('audioSource', url.substr(0, 128) + '...')
      // }else{
      //   console.log('audioSource', url)
      // }
      return url
    },
    playBtnIcon () {
      return this.isPlaying ? 'mdi-pause' : 'mdi-play'
    }
  },
  methods: {
    reload(){
      return new Promise((resolve)=>{
        // 透過 computed 更新&重設 audioSource
        console.log('audio player reload')
        this.reloading = true
        setTimeout(()=>{
          this.reloading = false
          resolve()
        }, 200)
      })
    },
    play(){
      this.player.play()
      this.$emit('play')
    },
    pause(opts = {}){
      this.player.pause()
      if(!opts.noEmit){
        this.$emit('pause')
      }
    },
    playback () {
      if (!this.audioSource) {
        return
      }

      if (this.isPlaying) {
        this.pause()
      } else {
        setTimeout(() => { this.play() }, 0)
      }

      this.isPlaying = !this.isPlaying
    },
    _resetProgress () {
      if (this.isPlaying) {
        this.pause()
      }

      this.duration = 0
      this.playedTime = 0
      this.progress = 0
      this.isPlaying = false
    },
    _onTimeUpdate () {
      this.playedTime = this.player.currentTime
      this.progress = (this.player.currentTime / this.player.duration) * 100
    },
    _onUpdateProgress (pos) {
      if (pos) {
        this.player.currentTime = pos * this.player.duration
      }
    },
    _onChangeVolume (val) {
      if (val) {
        this.player.volume = val
      }
    },
    _lineControlEvent(e){
      switch(e.type){
        case 'mousedown':
          this.isPlayingTmp = this.isPlaying
          if(this.isPlaying){
            this.pause()
          }
          this.isPlaying = false
          break
        case 'mouseup':
          this.isPlaying = this.isPlayingTmp
          if(this.isPlaying){
            this.play()
          }
          this.isPlayingTmp = null
          break
      }
    }
  }
}
</script>
<style scoped>
  .ar-player__progress{
    max-width: 30vw;
    width: 200px;
    min-width: 100px;
  }
  .ar-control>*{
    margin-right: 0.5rem;
    margin-left: 0.5rem;
  }
</style>
